module.exports = __webpack_public_path__ + "img/buy_normal_ko.c3eb50e5.png";